import { FC, useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { Alert, Modal, Spinner } from 'reactstrap';
import { updateSettingType } from 'src/services/settings-service';
import { ISettingType } from 'src/services/types';
interface IProps {
    item: ISettingType | null;
    show: boolean;
    onCancel: () => void;
    onRefresh: () => void;
}

export const EditRelevanceModal: FC<IProps> = ({
    show,
    onCancel, 
    onRefresh,
    item
}) => {
    const [relevanceValue, setRelevanceValue] = useState<number>();
    const [loading, setLoading] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>('');

    useEffect(() => {
        setErrorMessage('');
        setRelevanceValue(item?.globalRelevance);
    } , [item]);

    const onSave = async () => {
        setLoading(true);
        setErrorMessage('');
        const res = await updateSettingType(item?.id!, { globalRelevance: relevanceValue });
        if (res.result === 'ok') {
            toast('Relevance Type Setting updated successfully', { type: 'success'});
            onRefresh();
            onCancel();
        } else {
            setErrorMessage(res.message);
        }
        setLoading(false);
    }

  return (
    
    <Modal
        isOpen={show}
        backdrop={"static"}
        id="staticBackdrop"
    >
        <div className="modal-header">
            <h5 className="modal-title" id="staticBackdropLabel">
                Edit Relevance Type <b>"{item?.name}"</b>
            </h5>
        </div>
        <div className="modal-body">
            <p>
                Relevance
            </p>
            <div className='d-flex justify-content-center align-items-center '>
                {
                    Array.from({length: 11}, (_, i) => (
                        <button
                            key={i}
                            type="button"
                            className={`btn btn-rounded waves-effect waves-light mx-1` + ((relevanceValue === i) ? ' btn-primary ' : ' btn-light ')}
                            onClick={() => setRelevanceValue(i)}
                        >
                            { i }
                        </button>
                    ))
                }
            </div>
            {
                errorMessage && (
                    <Alert isOpen={!!errorMessage} toggle={()=>setErrorMessage('')}  color="danger" className="my-3">
                        { errorMessage }
                    </Alert>
                )
            }
        </div>
        <div className="modal-footer">
            <button
                type="button"
                className="btn btn-light"
                onClick={() => onCancel()}
            >
                Cancel
            </button>
            <button 
                type="button" 
                className="btn btn-primary fw-semibold"
                onClick={() => loading ? null : onSave()}
            >
                {
                loading ? (
                    <div className='d-flex align-items-center'>
                        <Spinner size="sm" color="light" />
                        <span className="text-white mx-2">Saving...</span>
                    </div>
                    
                ) : (
                    <span className="">Save</span>
                )}
            </button>
        </div>
    </Modal>
  )
}
